var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9909,
    cy: 13,
    rx: 12.9909,
    ry: 13,
    fill: "#006B00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54 13.5C7.54 12.124 7.804 11.04 8.332 10.248C8.868 9.456 9.728 9.06 10.912 9.06C12.096 9.06 12.952 9.456 13.48 10.248C14.016 11.04 14.284 12.124 14.284 13.5C14.284 14.892 14.016 15.984 13.48 16.776C12.952 17.568 12.096 17.964 10.912 17.964C9.728 17.964 8.868 17.568 8.332 16.776C7.804 15.984 7.54 14.892 7.54 13.5ZM12.268 13.5C12.268 12.692 12.18 12.072 12.004 11.64C11.828 11.2 11.464 10.98 10.912 10.98C10.36 10.98 9.996 11.2 9.82 11.64C9.644 12.072 9.556 12.692 9.556 13.5C9.556 14.044 9.588 14.496 9.652 14.856C9.716 15.208 9.844 15.496 10.036 15.72C10.236 15.936 10.528 16.044 10.912 16.044C11.296 16.044 11.584 15.936 11.776 15.72C11.976 15.496 12.108 15.208 12.172 14.856C12.236 14.496 12.268 14.044 12.268 13.5ZM15.1521 11.148V9.24H18.4761V18H16.3401V11.148H15.1521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.19ad7186ab9b26a3907f60fbba758a84.svg";
export { ForwardRef as ReactComponent };